import { supabase } from './supabase';
import type { Country } from './localData';

// Text-only — sends just the numeric series (no photo, no other health
// data) via the recommend-lab-trend Edge Function. Always a suggestion to
// review, never a diagnosis, per docs/AI_RULES.md.
export interface LabTrendReading {
  takenOn: string;
  value: number;
  unit?: string;
  referenceLow?: number;
  referenceHigh?: number;
}

export async function recommendLabTrend(analyte: string, country: Country, readings: LabTrendReading[], model: string): Promise<string> {
  if (!supabase) throw new Error('Supabase не настроен');
  const { data, error } = await supabase.functions.invoke('recommend-lab-trend', {
    body: { analyte, country, readings, model },
  });
  if (error) {
    let message = error.message;
    if ('context' in error && error.context instanceof Response) {
      try {
        const body = await error.context.clone().json();
        if (body?.error) message = body.error;
      } catch {
        // ignore — fall back to the generic error.message
      }
    }
    throw new Error(message);
  }
  const summary = (data as { summary?: string })?.summary;
  if (!summary) throw new Error('Не удалось получить рекомендацию');
  return summary;
}
